var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayButtonSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5410156,13.6621094L7.1943359,2.2265625C6.8935547,2.078125,6.5556641,2,6.2177734,2 C4.9951172,2,4,2.9951172,4,4.2177734v23.5644531C4,29.0048828,4.9951172,30,6.2177734,30 c0.3378906,0,0.6757812-0.078125,0.9755859-0.2255859l23.3466797-11.4365234C31.4267578,17.9052734,32,16.9873047,32,16 S31.4267578,14.0947266,30.5410156,13.6621094z M29.6621094,16.5410156L6.2177734,28C6.0976562,28,6,27.9023438,6,27.7822266 V4.2177734C6,4.109375,6.0800781,4.0185547,6.2548828,4.0185547c0.0185547,0,0.0380859,0.0009766,0.0595703,0.0039062 l23.3486328,11.4365234C29.8671875,15.5595703,30,15.7714844,30,16S29.8671875,16.4404297,29.6621094,16.5410156z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonSmall);
export default __webpack_public_path__ + "static/media/play-button--small.57236f35b91c1bd632439cfe13e3e953.svg";
export { ForwardRef as ReactComponent };